import type { SxProps } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { RelativeTimestamp } from '@/shared/ui';
import type { IntegrationStatus } from '../../model/types';
import { IntegrationStatusIndicator } from '../IntegrationStatusIndicator/IntegrationStatusIndicator';

interface Props {
  sx?: SxProps;
  status?: IntegrationStatus;
  lastSuccessfulSync?: string;
}

export function IntegrationSyncInfo({ sx, status, lastSuccessfulSync }: Props) {
  if (status === undefined && !lastSuccessfulSync) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      {status !== undefined && <IntegrationStatusIndicator status={status} />}
      {lastSuccessfulSync && (
        <Typography
          sx={{
            fontSize: '0.875rem',
            color: 'var(--blue-grey-700)',
            whiteSpace: 'nowrap',
          }}
        >
          Last sync: <RelativeTimestamp date={lastSuccessfulSync} />
        </Typography>
      )}
    </Box>
  );
}
